"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCatalogueCompanies = void 0;
/**
 * Allows you to remove companies/company from a catalogue
 */
var deleteCatalogueCompanies = function (instance) { return function (id, config) {
    return instance.delete("/catalogues/".concat(id, "/companies/delete"), config);
}; };
exports.deleteCatalogueCompanies = deleteCatalogueCompanies;
